import type { AttributeReviewValueFixInput } from "@/graphql/generated";
import {
  canPickAgain,
  valueRow,
  type PoolChoice,
  type PoolValue,
} from "./valueView";

const LOOK_REASONS: Record<string, string> = {
  ai: "AI guess",
  new: "New value, not in our list yet",
  "not in list": "Not in this closed list",
  "not checked": "Not checked yet",
};
const CLOSED_MATCHES = new Set(["not in list", "not checked"]);

export const droppedNote = (v: PoolValue) =>
  v.match === "ai" && v.dropped_words?.length
    ? `word dropped: ${v.dropped_words.join(", ")}`
    : null;

export function valueLook(
  v: PoolValue,
  fix: AttributeReviewValueFixInput | undefined,
  choices: PoolChoice[],
) {
  const row = valueRow(v, fix, choices);
  const words = droppedNote(v) ?? LOOK_REASONS[v.match] ?? "";
  const reason = row.ignored
    ? ""
    : CLOSED_MATCHES.has(v.match)
      ? row.attention
        ? words
        : ""
      : (row.attention ?? (fix ? "" : words));
  return {
    row,
    reason,
    visible:
      Boolean(reason) ||
      Boolean(words) ||
      Boolean(fix) ||
      (row.ignored && canPickAgain(v)),
  };
}

export const countDropped = (
  values: PoolValue[],
  fixes: Record<string, AttributeReviewValueFixInput>,
) =>
  values.filter((v) => !v.ignored && !fixes[v.store_value] && droppedNote(v))
    .length;

export const countLooks = (
  values: PoolValue[],
  fixes: Record<string, AttributeReviewValueFixInput>,
  choices: PoolChoice[],
) =>
  values.filter((v) => valueLook(v, fixes[v.store_value], choices).reason)
    .length;
